import { ISettingsContainerState } from "@montana/containers/settings/settings";
import {IProductDimension, IOption, IStore, IColorModel} from "@montana/models/generated/cms.interface";
import { ILocation } from "@montana/shared/map";

/**
 * Product
 *  IProductConfigOption is our own type, created to hold a config of a product, but it can be either a
 *  IDimensionSelector extended by IDimensionOption - therefor type has to be optional.
 */
export type IProductConfigOption = Partial<IProductDimension> & Partial<IOption> & Partial<IColorModel>;

export interface IProductConfig {
    code?: string;
    cylindoSku?: string;
    dimensions?: IProductConfigOption[];
    quantity?: number;
    queryString?: string;
    measurement?: string;
    isDefaultConfig?: boolean;
}

export enum MegaMenuTypes {
    None = 'none',
    Products = 'product',
    Discover = 'discovery',
    Inspiration = 'inspiration',
    Download = 'download',
}

export interface IVariantInfoRequest {
    code: string;
    dimensions: string[];
}

export enum SortingOption {
    AZ = 'sortAZ',
    ZA = 'sortZA',
    New = 'sortNew',
    Cheap = 'sortCheap',
    Expensive = 'sortExpensive',
    Manual = "sortManual"
}

export interface IEnhancedStore extends IStore {
    distance?: number;
    location?: ILocation;
    selectedProduct?: boolean;
}

export interface IFEBLock {
    isFirstOnPage?: boolean;
}

export type IRequestHeaderConfig = Partial<Omit<ISettingsContainerState, "infoToolboxs">>;

export type OmitConfig<TFun> = TFun extends (config: IRequestHeaderConfig, ...args: infer TArgs) => infer TReturn
    ? (...args: TArgs) => TReturn
    : TFun;
